export default __webpack_public_path__ + "static/3-e46b2fe9bccd0b0a7f4ed9a3d84d0bfc.jpg";